<template>
  <v-col
    v-if="mfaEnabled"
    lg="6"
  >
    <v-alert
      outlined
      type="info"
    >
      <p>Multi-factor authentication has been enabled for your login. </p>
      <p>
        If you need to remove multi-factor authentication or change the phone number to which verification codes are sent, please <support-link subject="Multi factor authentication">
          contact support
        </support-link> from the email address you use to login ({{ user.email }}).
      </p>
    </v-alert>
  </v-col>
  <div v-else>
    <enable-mfa v-if="user.emailVerified" />
    <v-row
      v-else
      justify="space-around"
    >
      <v-col lg="6">
        <v-alert
          outlined
          type="info"
        >
          You need to confirm your email address before you can set up
          mult-factor authentication. If you have already confirmed your email
          address but still see this, you may need to refresh the page.
        </v-alert>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import EnableMfa from '@/components/auth/mfa/enable/EnableMfa.vue'
import SupportLink from '@/components/SupportLink.vue'

export default {
  name: 'ManageMfa',
  components: {
    EnableMfa,
    SupportLink
  },
  beforeCreate() {
    this.mapStates(['mfaEnabled', 'user'])
  }
}
</script>
